import React from 'react';
import './Chapters.scss';
import PullQuote from '../PullQuote/PullQuote';

function Chapter4() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__paragraph">
          Ken Wilkinson, Managing Partner of collaborating tech solutions company Layer 10, calls it
          a new frontier of development. “Intel is building a coalition of ecosystem partners behind
          the scenes to marry the Information Technology to the Operations Technology for a fully
          integrated technology tech stack to deliver these abilities.”
        </p>
        <p className="chapter__title" style={{ marginTop: '2rem' }}>
          The Building of a SmartTown
        </p>
        <p className="chapter__paragraph">
          The process of creating Miller’s Landing is unique because it was planned with technology
          and construction in concert rather than the traditional way of building first and adding
          tech later.
        </p>
        <p className="chapter__paragraph">
          Wilkinson says there has been a recent shift in developers’ mindsets in regard to
          technology. “Traditionally, IT was given short shrift. It was an afterthought, left up to
          the architect, who punted to the general contractor, who handed it off to the
          electrician,” Wilkinson says. “It was a hot potato nobody wanted to be caught holding. But
          that’s what is unique about Miller’s Landing. We have adopted user design theory to lead
          first with the experience, translate that into ‘day in the life’ scenarios, and only then
          seek technologies that can transform these experiences into reality.”
        </p>
      </section>
      <section>
        <PullQuote
          quote={
            'Traditionally, IT was given short shrift. It was an afterthought, left up to the architect, who punted to the general contractor, who handed it off to the electrician. It was a hot potato nobody wanted to be caught holding. But that’s what is unique about Miller’s Landing. '
          }
          author={'Ken Wilkinson,'}
          source={'Layer 10'}
        />
      </section>
      <section className="chapter">
        <p className="chapter__title">Why Miller’s Landing?</p>
        <p className="chapter__paragraph">
          The reason Miller’s Landing is so unique, Ilhan suggests, is the natural Colorado
          landscape combined with the frictionless interconnectivity that Intel enables together
          with its extensive ecosystem. Miller’s Landing features many outdoor elements and
          amenities, and it’s within walking distance of 300-acre Philip S. Miller Park. Colorado’s
          natural beauty combined with SmartTown connectedness provides a dynamic setting. And the
          setting cannot be overstated. "This community will be supported with the premium
          technology needed to create its experiences and efficiencies,” says Intel’s Rick Hack,
          Head of Media and Entertainment Partnerships. “However, it will be done in authentic ways
          and means so as to blend into the background of its scenic environment.”
        </p>

        <p className="chapter__paragraph">
          Temple says the picturesque locale is indeed the biggest draw, with “a walkable
          neighborhood with great trails and immediate connection to Philip Miller Park and over 300
          days of sunshine in the second healthiest county in the country.”
        </p>
        <p className="chapter__paragraph">
          Food is another aspect of the area’s healthy lifestyle, and food at Miller’s Landing is a
          plus in Ilhan’s book: Residents and visitors will have streamlined access to fresh and
          organic foods via autonomous grocery stores. “As a customer, you walk in, you grab things,
          which are automatically charged or connected to your room,” Ilhan says.
        </p>
      </section>
    </>
  );
}

export default Chapter4;
